/**
 * Escudos dos clubes das ligas estrangeiras: public/escudos/<país>/<SIGLA>.svg. O arquivo é achado pelo nome do clube como aparece
 * nas planilhas (ver ligas-mundo-elencos.ts). Clube sem arquivo aparece com o círculo neutro. Por enquanto só a Espanha tem escudos.
 * Siglas de países diferentes podem se repetir (ATH do Athletic Bilbao e do Athletic-MG), por isso cada país tem a sua pasta.
 */
export const ESCUDOS_MUNDO: Record<string, string> = {
  // La Liga
  'Real Madrid': 'es/RMA',
  'FC Barcelona': 'es/FCB',
  'Atlético de Madrid': 'es/ATM',
  'Villarreal CF': 'es/VIL',
  'Real Sociedad': 'es/RSO',
  'Real Betis Balompié': 'es/BET',
  'Athletic Bilbao': 'es/ATH',
  'Celta de Vigo': 'es/CEL',
  'Sevilla FC': 'es/SEV',
  'Valencia CF': 'es/VAL',
  'RCD Espanyol Barcelona': 'es/ESP',
  'Deportivo A Coruña': 'es/DEP',
  'Racing Santander': 'es/RAC',
  'Rayo Vallecano': 'es/RAY',
  'Getafe CF': 'es/GET',
  'Levante UD': 'es/LEV',
  'CA Osasuna': 'es/OSA',
  'Elche CF': 'es/ELC',
  'Málaga CF': 'es/MLG',
  // La Liga 2
  'UD Almería': 'es/ALM',
  'Girona FC': 'es/GIR',
  'RCD Mallorca': 'es/MAL',
  'Real Oviedo': 'es/OVI',
  'UD Las Palmas': 'es/LPA',
  'CD Leganés': 'es/LEG',
  'Real Valladolid CF': 'es/VAD',
  'Cádiz CF': 'es/CAD',
  'Sporting Gijón': 'es/SPO',
  'CD Castellón': 'es/CAS',
  'Burgos CF': 'es/BUR',
  'Granada CF': 'es/GRA',
  'SD Eibar': 'es/EIB',
  'Albacete Balompié': 'es/ALB',
  'Córdoba CF': 'es/COR',
  'FC Andorra': 'es/AND',
  'CD Eldense': 'es/ELD',
  'CE Sabadell FC': 'es/SAB',
  'CD Tenerife': 'es/TEN',
  'AD Ceuta FC': 'es/CEU',
};